<template>
  <div class="app-store-badges">
    <a :href="appStoreUrl" target="_blank" rel="noopener">
      <b-img
        :src="require(`@base/assets/images/badges/download-on-the-app-store-${$_languageCode}.svg`)"
        width="160"
        height="53"
        alt="App Store"
      />
    </a>
    <a :href="playMarketUrl" target="_blank" rel="noopener">
      <b-img
        :src="require(`@base/assets/images/badges/google-play-badge-${$_languageCode}.png`)"
        width="160"
        height="53"
        alt="Google Play"
      />
    </a>
  </div>
</template>

<script>
  import { APP_STORE_URL, PLAY_MARKET_URL } from '@base/configs'

  export default {
    name: 'AppStoreBadges',

    data () {
      return {
        appStoreUrl: APP_STORE_URL,
        playMarketUrl: PLAY_MARKET_URL,
      }
    },
  }
</script>

<style scoped>
  .app-store-badges {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
  }

  .app-store-badges img {
    width: 160px;
    height: 53px;
    max-width: none;
  }
</style>
